import { Panel } from "@/components/atoms";
import { CustomApplicationAnswers } from "../ApprovedDriver/sections/CustomApplicationAnswers";
import { PendingDriverAccountDetails } from "./sections/PendingDriverAccountDetails";
import { PendingDriverDetails } from "./sections/PendingDriverDetails";
import { PendingDriverHeader } from "./sections/PendingDriverHeader";
import { PendingDriverStatus } from "./sections/PendingDriverStatus";

export const PendingDriverPanel = () => {
  return (
    <Panel>
      <PendingDriverHeader />
      <PendingDriverStatus />
      <CustomApplicationAnswers />
      <PendingDriverAccountDetails />
      <PendingDriverDetails />
    </Panel>
  );
};
